export default "__VITE_ASSET__DhJp8IJM__"